<template>
  <div :style="`width: ${isCollapse ? '64px' : '100%'}; ${isCollapse ? 'transition: width 0.3s ease;' : 'transition: width 0.3s ease 0.3s;'} display: flex; align-items: center; position: relative;`">
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @select="handleSelect"
      :collapse="isCollapse"
      style="position: relative;"
    >
      <el-menu-item index="/representative-processes/receipt-receives/invoice" route="/representative-processes/receipt-receives/invoice" v-can="'receiptreceives.view'">
        <i class="el-icon-document" />
        <span>Számla</span>
      </el-menu-item>
      <el-menu-item index="/representative-processes/receipt-receives/delivery" route="/representative-processes/receipt-receives/delivery" v-can="'receiptreceives.view'">
        <i class="el-icon-truck" />
        <span>Szállítólevél</span>
      </el-menu-item>
    </el-menu>
    <el-button
      :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-left'"
      circle
      size="mini"
      :style="`position: absolute; right: 0; transform: translateX(50%) translateY(-50%); top: 50%; ${isCollapse ? 'transform: rotateZ(180deg) translate(-50%, 50%);' : ''} ${isCollapse ? 'transition: 0.3s;' : 'transition: 0.3s ease 0.3s;'} `"
      @click="handleCollapse"
    ></el-button>
  </div>
</template>
<script>
export default {
  computed: {
    isCollapse() {
      return this.$store.getters['sidebar/isReceiptReceiveSidebarCollapse'];
    },
  },
  methods: {
    handleSelect(path) {
      this.$router.push(path);
    },
    handleCollapse() {
      if(this.isCollapse) {
        this.$store.commit('sidebar/setIsReceiptReceiveSidebarCollapse', false);
      } else {
        this.$store.commit('sidebar/setIsReceiptReceiveSidebarCollapse', true) ;
      }
    }
  }
};
</script>

<style scoped>
  .el-menu-vertical-demo > .el-menu-item.is-active {
    border-right: 2px solid #409EFF;
    transition: 0.3s;
    background: #ecf5ff;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
</style>
